var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:system:user:withdraw:config:list"],
            expression: "['platform:system:user:withdraw:config:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          immediate: false,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["platform:system:user:withdraw:config:save"],
                        expression:
                          "['platform:system:user:withdraw:config:save']",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("添加")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:system:user:withdraw:config:update",
                                  ],
                                  expression:
                                    "['platform:system:user:withdraw:config:update']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleActivity(row, "edit")
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }